export default __webpack_public_path__ + "images/54_thumbnail.jpg";